// import utf8 from 'utf8';
import iconv from 'iconv-lite';

export const decoders = {
  'big5': decodeByTextDecoder('big5'),
  'gbk': decodeByTextDecoder('gbk'),
  'gb18030': decodeByTextDecoder('gb18030'),
  'iso-8859-1': decodeByTextDecoder('iso-8859-1'),
  'iso-8859-2': decodeByTextDecoder('iso-8859-2'),
  'iso-8859-3': decodeByTextDecoder('iso-8859-3'),
  'iso-8859-4': decodeByTextDecoder('iso-8859-4'),
  'iso-8859-5': decodeByTextDecoder('iso-8859-5'),
  'iso-8859-6': decodeByTextDecoder('iso-8859-6'),
  'iso-8859-7': decodeByTextDecoder('iso-8859-7'),
  'iso-8859-8': decodeByTextDecoder('iso-8859-8'),
  'iso-8859-10': decodeByTextDecoder('iso-8859-10'),
  'iso-8859-13': decodeByTextDecoder('iso-8859-13'),
  'iso-8859-14': decodeByTextDecoder('iso-8859-14'),
  'iso-8859-15': decodeByTextDecoder('iso-8859-15'),
  'koi8-r': decodeByTextDecoder('koi8-r'),
  'koi8-u': decodeByTextDecoder('koi8-u'),
  'macintosh': decodeByTextDecoder('macintosh'),
  'ibm866': decodeByTextDecoder('ibm866'),
  // 'utf-8': text => {
  //   const utf = utf8;
  //   try {
  //     return utf8.decode(text);
  //   } catch (err) {
  //     console.error('utf-8', 'не действительный тип кодировки');
  //     return text;
  //   }
  // },
  'url': text => decodeURIComponent(text),
  'windows-874': decodeByTextDecoder('windows-874'),
  'windows-1250': decodeByTextDecoder('windows-1250'),
  'windows-1251': decodeByTextDecoder('windows-1251'),
  'windows-1252': decodeByTextDecoder('windows-1252'),
  'windows-1253': decodeByTextDecoder('windows-1253'),
  'windows-1254': decodeByTextDecoder('windows-1254'),
  'windows-1255': decodeByTextDecoder('windows-1255'),
  'windows-1256': decodeByTextDecoder('windows-1256'),
  'windows-1257': decodeByTextDecoder('windows-1257'),
  'windows-1258': decodeByTextDecoder('windows-1258'),
  'x-mac-cyrillic': decodeByTextDecoder('x-mac-cyrillic'),

};

function decodeByTextDecoder(type) {
  let decoder;
  try {
    decoder = new TextDecoder(type);

  } catch (e) {
    console.error(type, 'недействительный тип кодировки');
    return text => text;
  }

  return text => {

    const bufer = iconv.encode(text, type);
    try {
      // const decoded = iconv.decode(bufer, k);
      return iconv.decode(bufer, 'utf-8');
    } catch (err) {
      console.error(type, 'не вылшо');
      return text;
    }

  };
}

const liElement = type => {
  return `<li >
    <a ng-click="decodeText($event,'${type}')">${type}</a>
  </li>`;
};


export const decoderElement = () => {
  let list = '';
  Object.keys(decoders).forEach(d => {
    list += liElement(d);
  });


  return `
  <span class="dropdown decoder-element">
    <i data-toggle="dropdown"
      class="icon-cogs dropdown-toggle"
      style="color: gray;"
    ></i>
    <ul class="dropdown-menu pull-right"  >` + list +
    `</ul>
  </span>
  `;
};



// WEBPACK FOOTER //
// ./src/facts/decode-fact.js